import { useKeycloak } from '@react-keycloak/web';
import React, { type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import Page404 from '../../pages/Error/Page404';

interface AuthenticatorProps {
  children: ReactNode;
}

interface RootState {
  status: {
    error: string | null;
  };
  user: {
    uuid: string;
  };
}

const Authenticator = ({ children }: AuthenticatorProps): React.ReactNode => {
  const { keycloak, initialized } = useKeycloak();
  const reduxError = useSelector((state: RootState) => state.status.error);
  const user = useSelector((state: RootState) => state.user);
  const { pathname } = useLocation();

  const protectedPaths = [
    '/account',
    '/governance/organizations',
    '/organizations',
    '/organization',
    '/reports',
    '/monitoring-dashboard',
    '/projects',
    '/products',
    '/users',
    '/business-units',
  ];

  const publicPaths = [
    '/products/monitoring/specification',
    '/products/compute/specification',
    '/products/safescarf/specification',
    '/products/caas/specification',
    '/products/baremetal/specification',
  ];

  const authenticatedPath = protectedPaths.find(
    path => pathname.startsWith(path) && !publicPaths.includes(pathname)
  );

  if (authenticatedPath) {
    if (reduxError === 'KEYCLOAK_INIT_ERROR') return <Page404 />;
    if (!initialized) return <p>Initializing...</p>;
    if (!keycloak.authenticated) {
      keycloak.login({ redirectUri: `${window.location.origin}${pathname}` });
    }
    if (!user.uuid) return <p>Getting user details...</p>;
  }
  return children;
};

export default Authenticator;
